import React, { useId } from 'react';
import {
    Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Toolbar, Typography, IconButton, Box, Chip
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useOCRStore } from '../store/ocrStore';

export const CustomFieldsTable: React.FC = () => {
    const { t } = useTranslation();
    const headingId = useId();
    const customFields = useOCRStore((state) => state.customFields);
    const removeCustomField = useOCRStore((state) => state.removeCustomField);

    if (customFields.length === 0) {
        return null;
    }

    return (
        <Paper elevation={3} sx={{ mb: 3, borderRadius: 2, overflow: 'hidden' }}>
            <Toolbar sx={{ backgroundColor: 'primary.grey', color: 'primary.contrastText' }}>
                <Typography id={headingId} variant="h3" sx={{ flex: 1 }}>{t('logbookConfig.manuallyAddedFields', 'Manually Added Fields')}</Typography>
            </Toolbar>
            <TableContainer>
                <Table aria-labelledby={headingId} size="small" sx={{ minWidth: '100%', borderCollapse: 'collapse' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid', borderColor: 'divider', p: 1.5 }}>{t('logbookConfig.label', 'Label')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid', borderColor: 'divider', p: 1.5 }}>{t('logbookConfig.dataType', 'Data Type')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid', borderColor: 'divider', p: 1.5, textAlign: 'right' }}>{t('table.actions', 'Actions')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {customFields.map((field, index) => (
                            <TableRow
                                key={field.id}
                                sx={{
                                    '&:nth-of-type(odd)': { backgroundColor: 'action.hover' },
                                    '&:hover': { backgroundColor: 'action.selected' },
                                }}
                            >
                                <TableCell sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                    <Typography variant="body1">{field.label}</Typography>
                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Chip label={field.dataType} size="small" variant="outlined" />
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5, textAlign: 'right' }}>
                                    <IconButton
                                        aria-label={t('logbookConfig.removeField', 'Remove {{label}}', { label: field.label })}
                                        onClick={() => removeCustomField(field.id)}
                                        color="error"
                                        size="small"
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};